var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIconOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 52.5C50 49.0111 50 47.2666 49.5694 45.8471C48.5999 42.6511 46.0989 40.1501 42.9029 39.1806C41.4834 38.75 39.7389 38.75 36.25 38.75H23.75C20.2611 38.75 18.5166 38.75 17.0971 39.1806C13.9011 40.1501 11.4001 42.6511 10.4306 45.8471C10 47.2666 10 49.0111 10 52.5M41.25 18.75C41.25 24.9632 36.2132 30 30 30C23.7868 30 18.75 24.9632 18.75 18.75C18.75 12.5368 23.7868 7.5 30 7.5C36.2132 7.5 41.25 12.5368 41.25 18.75Z",
    stroke: "#475467",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconOutline);
export default __webpack_public_path__ + "static/media/user-icon-outline.7db4149d15d58e5c0b6272e6f97cc3a4.svg";
export { ForwardRef as ReactComponent };